(function () {
  'use strict';

  // Promo Aceite (home) — 03/09/2026 · mobile aligerado + agregar al carrito 07/09/2026
  // Escalera de 3 escalones cuyo último escalón depende del bidón elegido.
  // Los porcentajes vienen del theme editor y tienen que coincidir con los
  // descuentos automáticos del Admin y con la landing (/pages/aceite-de-oliva).
  //
  // 07/09/2026 (a) — En celular cada escalón muestra dos datos en vez de tres.
  //   Los meses de aceite aparecen una sola vez, en el total. Desktop igual.
  // 07/09/2026 (b) — El botón agrega al carrito y abre el drawer en vez de
  //   mandar a la landing. El descuento lo aplica Shopify solo (descuentos
  //   automáticos por cantidad), así que el total del carrito coincide con el
  //   que muestra esta sección. Si falla el fetch, cae a la landing.

  var cfg = window.qnAoConfig || {};
  var prices = { 1: cfg.bottle1Price || 1990, 2: cfg.bottle2Price || 3290 };
  var names = { 1: cfg.bottle1Name || 'Bidón 3L', 2: cfg.bottle2Name || 'Bidón 5L' };
  var liters = { 1: cfg.bottle1Liters || 3, 2: cfg.bottle2Liters || 5 };
  var variantIds = { 1: cfg.bottle1VariantId || '', 2: cfg.bottle2VariantId || '' };
  var singleShip = { 1: cfg.bottle1SingleShipping || 'paid', 2: cfg.bottle2SingleShipping || 'free' };
  var perMonth = cfg.litersPerMonth || 1;
  var cuotas = cfg.cuotas || 10;
  var landingUrl = cfg.landingUrl || '/pages/aceite-de-oliva';

  var current = { bottle: 1, tierEl: null };

  function money(n) {
    return '$' + Math.round(n).toLocaleString('es-UY');
  }

  function lcFirst(s) {
    return s.charAt(0).toLowerCase() + s.slice(1);
  }

  // Los dos textos (desktop / celular) viven juntos; los muestra el CSS.
  function twoUp(deskText, mobText) {
    return '<span class="qn-ao-only-desk">' + deskText + '</span>'
         + '<span class="qn-ao-only-mob">' + mobText + '</span>';
  }

  function tierData(el) {
    var qty = parseInt(el.getAttribute('data-qty-b' + current.bottle), 10) || 1;
    var disc = parseInt(el.getAttribute('data-disc'), 10) || 0;
    return { qty: qty, disc: disc };
  }

  function shippingText(qty) {
    var free = qty > 1 || singleShip[current.bottle] === 'free';
    return free ? (cfg.shippingFreeText || 'Envío gratis') : (cfg.shippingPaidText || 'Envío pago');
  }

  function monthsText(totalLiters) {
    var m = Math.round(totalLiters / perMonth);
    if (m >= 12 && m % 12 === 0) return (m / 12 === 1 ? 'Un año' : (m / 12) + ' años') + ' de aceite';
    return m + ' meses de aceite';
  }

  // Rellena nombre / detalle / pill de cada escalón según el bidón activo
  function paintTiers() {
    document.querySelectorAll('.qn-ao-tier').forEach(function (el) {
      var d = tierData(el);
      var totalL = d.qty * liters[current.bottle];
      var base = prices[current.bottle] * d.qty;
      var total = base * (1 - d.disc / 100);
      var perLiter = total / totalL;

      var nameEl = el.querySelector('[data-tier-name]');
      var detailEl = el.querySelector('[data-tier-detail]');
      var pillEl = el.querySelector('[data-tier-pill]');

      if (nameEl) nameEl.textContent = d.qty + (d.qty > 1 ? ' bidones' : ' bidón');
      if (detailEl) {
        detailEl.innerHTML = twoUp(
          totalL + ' litros · ' + monthsText(totalL) + ' · ' + money(perLiter) + ' por litro',
          totalL + ' L · ' + money(perLiter) + ' el litro'
        );
      }
      if (pillEl) pillEl.textContent = (d.disc > 0 ? '-' + d.disc + '% · ' : '') + shippingText(d.qty);
    });
  }

  function calc() {
    if (!current.tierEl) return;
    var d = tierData(current.tierEl);
    var base = prices[current.bottle] * d.qty;
    var total = Math.round(base * (1 - d.disc / 100));
    var saving = base - total;
    var totalL = d.qty * liters[current.bottle];

    var priceEl = document.getElementById('qnAoPriceVal');
    var unitEl = document.getElementById('qnAoPriceUnit');
    var savingsEl = document.getElementById('qnAoSavings');
    var savingsValEl = document.getElementById('qnAoSavingsVal');
    var wasEl = document.getElementById('qnAoWas');
    var cuotasEl = document.getElementById('qnAoCuotas');

    if (priceEl) priceEl.textContent = money(total);
    if (unitEl) {
      var qtyTxt = d.qty + (d.qty > 1 ? ' bidones' : ' bidón');
      unitEl.innerHTML = twoUp(
        qtyTxt + ' · ' + names[current.bottle] + ' · ' + money(total / totalL) + ' por litro',
        totalL + ' litros · ' + lcFirst(monthsText(totalL))
      );
    }
    if (savingsEl && savingsValEl) {
      if (saving > 0) {
        savingsEl.classList.remove('hidden');
        savingsValEl.textContent = money(saving);
        if (wasEl) wasEl.textContent = 'antes ' + money(base);
      } else {
        savingsEl.classList.add('hidden');
        if (wasEl) wasEl.textContent = '';
      }
    }
    if (cuotasEl) {
      cuotasEl.innerHTML = 'O en ' + cuotas + ' pagos de <strong>' + money(total / cuotas) + '</strong> '
        + (cfg.cuotasLabel || 'sin interés');
    }
  }

  // --- Agregar al carrito ---------------------------------------------------

  // Abre el carrito real. Si el drawer no está, cae a /cart.
  function openCart() {
    if (typeof window.qnOpenCart === 'function') { window.qnOpenCart('/'); return; }
    var D = window.QNCartDrawer;
    if (!D || typeof D.open !== 'function') { window.location.href = '/cart'; return; }
    var refresh = null;
    try { if (typeof D.fetchCart === 'function') refresh = D.fetchCart(); } catch (e) { refresh = null; }
    Promise.resolve(refresh).catch(function () {}).then(function () {
      try { D.open(); } catch (e) { window.location.href = '/cart'; }
    });
  }

  function addToCart(btn) {
    var vid = variantIds[current.bottle];
    if (!vid || !current.tierEl) { window.location.href = landingUrl; return; }

    var d = tierData(current.tierEl);
    var txtEl = btn.querySelector('[data-ao-cta-txt]') || btn;
    var original = txtEl.textContent;

    btn.disabled = true;
    txtEl.textContent = 'Agregando…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid), quantity: d.qty }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.disabled = false;
        txtEl.textContent = original;
        openCart();
      })
      .catch(function () {
        // Si no se pudo agregar, la landing sigue siendo un camino válido.
        window.location.href = landingUrl;
      });
  }

  // --- API pública ----------------------------------------------------------

  window.qnAoSelectBottle = function (n) {
    current.bottle = n;
    var b1 = document.getElementById('qnAoB1');
    var b2 = document.getElementById('qnAoB2');
    if (b1) b1.classList.toggle('active', n === 1);
    if (b2) b2.classList.toggle('active', n === 2);
    document.querySelectorAll('[data-ao-pill]').forEach(function (p) {
      p.classList.toggle('active', parseInt(p.getAttribute('data-ao-pill'), 10) === n);
    });
    paintTiers();
    calc();
  };

  window.qnAoPickTier = function (el) {
    document.querySelectorAll('.qn-ao-tier').forEach(function (t) { t.classList.remove('active'); });
    el.classList.add('active');
    current.tierEl = el;
    calc();
  };

  function init() {
    var active = document.querySelector('.qn-ao-tier.active') || document.querySelector('.qn-ao-tier');
    current.tierEl = active;
    // Teclado: Enter/Espacio sobre bidones y escalones
    document.querySelectorAll('.qn-ao-tier, .qn-ao-bottle').forEach(function (el) {
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); el.click(); }
      });
    });
    document.querySelectorAll('[data-ao-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); addToCart(btn); });
    });
    paintTiers();
    calc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
